import React from 'react';
import classnames from 'classnames';
import styles from './sortableColumn.module.scss';
import arrowDown from 'v2/icons/arrowDown.svg';
import arrowUp from 'v2/icons//arrowUp.svg';

interface SortableColumnProps {
  label: string;
  currentField?: string | null;
  ascField: string;
  descField: string;
  onSortChange: (field: string) => void;
  className?: string;
}

const SortableColumn = ({
  label,
  ascField,
  descField,
  currentField,
  onSortChange,
  className,
}: SortableColumnProps) => {
  const handleClick = () => {
    const field = currentField === descField ? ascField : descField;
    onSortChange(field || '');
  };

  return (
    <p
      className={classnames('no-wraping-text', styles.sortColumn, className)}
      onClick={handleClick}
      data-cy={`column:sortable-${label.replaceAll(' ', '')}`}
    >
      {label}

      {currentField === descField && (
        <img
          src={arrowDown}
          alt="arrowDownIcon"
          className={classnames(styles.sortArrow)}
        ></img>
      )}
      {currentField === ascField && (
        <img
          src={arrowUp}
          alt="arrowUpIcon"
          className={classnames(styles.sortArrow)}
        ></img>
      )}
    </p>
  );
};

export default SortableColumn;
